import { motion } from "framer-motion";
import { ArrowRight, Instagram } from "lucide-react";

const AntesDepois = () => {
  // Fotos reais fornecidas pela clínica
  const cases = [
    {
      image: "https://customer-assets.emergentagent.com/job_dentista-viseu/artifacts/q1wi272a_Captura%20de%20ecra%CC%83%202026-04-02%2C%20a%CC%80s%2018.31.28.png",
      title: "Reabilitação Estética",
      description: "Facetas e branqueamento",
    },
    {
      image: "https://customer-assets.emergentagent.com/job_dentista-viseu/artifacts/7mbohrl6_DSC_7902%20-%20co%CC%81pia.JPG",
      title: "Ortodontia",
      description: "Alinhadores invisíveis",
    },
    {
      image: "https://customer-assets.emergentagent.com/job_dentista-viseu/artifacts/1482tear_DSC_4115.JPG",
      title: "Implantes Dentários",
      description: "Reabilitação completa",
    },
  ];

  return (
    <section
      id="antes-depois"
      className="py-16 md:py-24 bg-[#FAFAFA]"
      data-testid="antes-depois-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 md:mb-16"
        >
          <span className="text-xs font-semibold tracking-[0.15em] uppercase text-[#8A8A8A] block mb-4">
            Resultados Reais
          </span>
          <h2
            className="font-outfit text-3xl sm:text-4xl font-semibold text-[#1A1A1A] tracking-tight mb-4"
            data-testid="antes-depois-title"
          >
            Casos de Sucesso
          </h2>
          <p className="text-lg text-[#4A4A4A] max-w-2xl mx-auto">
            Transformações reais realizadas pela nossa equipa. Veja o que podemos fazer pelo seu sorriso.
          </p>
        </motion.div>

        {/* Cases Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {cases.map((caseItem, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group relative overflow-hidden rounded-2xl bg-white border border-gray-100 shadow-sm hover:shadow-xl transition-all"
              data-testid={`case-${index}`}
            >
              <div className="aspect-square overflow-hidden">
                <img
                  src={caseItem.image}
                  alt={caseItem.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                <h3 className="font-outfit text-xl font-semibold mb-1">
                  {caseItem.title}
                </h3>
                <p className="text-white/80 text-sm">{caseItem.description}</p>
              </div>
              <div className="p-6">
                <h3 className="font-outfit text-lg font-medium text-[#1A1A1A] mb-1">
                  {caseItem.title}
                </h3>
                <p className="text-[#4A4A4A] text-sm">{caseItem.description}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Instagram CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
          className="text-center mt-12"
        >
          <a
            href="https://www.instagram.com/cligeralcare/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-white text-[#1A1A1A] border-2 border-[#1A1A1A] rounded-full px-8 py-3.5 font-semibold hover:bg-[#1A1A1A] hover:text-white transition-all"
            data-testid="instagram-link"
          >
            <Instagram className="w-5 h-5" />
            Ver Mais no Instagram
            <ArrowRight className="w-4 h-4" />
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default AntesDepois;
